import React from "react";
import PropTypes from "prop-types";
import BlockContent from "@sanity/block-content-to-react";

import Heading from "../heading";
import Banner from "../banner";
import Button from "../button";

const serializers = {
  types: {
    banner: ({ node }) => {
      const { title, subtitle, buttonText, buttonUrl } = node;

      return (
        <Banner
          title={title}
          subtitle={subtitle}
          buttonText={buttonText}
          link={buttonUrl}
        />
      );
    },

    button: ({ node }) => {
      const { label, link, isExternalLink } = node;

      return (
        <span className="my-12 md:last:mb-0 block">
          <Button
            externalLink={isExternalLink ? link : null}
            link={!isExternalLink ? link : null}
            variant="secondary"
          >
            {label}
          </Button>
        </span>
      );
    },

    block(props) {
      switch (props.node.style) {
        // case "image":
        //   return <Figure {...props.node} />;

        case "h1":
          return (
            <Heading className="text-5xl mb-6" id={props.node._key}>
              {props.children}
            </Heading>
          );

        case "h2":
          return (
            <Heading className="text-4xl mb-6" id={props.node._key}>
              {props.children}
            </Heading>
          );

        case "h3":
          return (
            <Heading className="text-3xl mb-6" id={props.node._key}>
              {props.children}
            </Heading>
          );

        case "h4":
        case "h5":
        case "h6":
          return (
            <Heading className="text-2xl mb-6" id={props.node._key}>
              {props.children}
            </Heading>
          );

        default:
          return (
            <p className="text-xl mb-6 last:mb-0" id={props.node._key}>
              {props.children}
            </p>
          );
      }
    },
  },
};

const PortableText = ({ blocks }) => (
  <BlockContent blocks={blocks} serializers={serializers} />
);

PortableText.propTypes = {
  blocks: PropTypes.shape.isRequired,
};

export default PortableText;
